import { useParams } from 'react-router-dom'

import OrderProductionTree from './OrderProductionTree'

import './OrderProductionTree.css'

function OrderProductionTreePage() {
    const { id } = useParams()

    return (
        <div className="pg-page">
            <OrderProductionTree orderId={id} />
        </div>
    )
}

export default OrderProductionTreePage
